import {
  GET_DEPARTMENT_USERS_FAIL,
  GET_DEPARTMENT_USERS_REQUEST,
  GET_DEPARTMENT_USERS_SUCCESS,
  GET_USERS_DEPARTMENT_FAIL,
  GET_USERS_DEPARTMENT_REQUEST,
  GET_USERS_DEPARTMENT_SUCCESS,
} from '../../types/user/departTypes';

export const getDepartReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_USERS_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USERS_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        departInfo: payload,
        error: '',
      };
    case GET_USERS_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        departInfo: {},
      };
    default:
      return state;
  }
};

export const getDepartUsersReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_DEPARTMENT_USERS_REQUEST:
      return {
        ...state,
        departLoading: true,
      };
    case GET_DEPARTMENT_USERS_SUCCESS:
      return {
        ...state,
        departLoading: false,
        departUserInfo: payload,
        departError: '',
      };
    case GET_DEPARTMENT_USERS_FAIL:
      return {
        ...state,
        departLoading: false,
        departError: payload,
        departUserInfo: {},
      };
    default:
      return state;
  }
};
